<div class="tabs-header">
  <div *ngIf="showPrefix" class="prefix">
    <ng-container *ngIf="prefixTemplate" [ngTemplateOutlet]="prefixTemplate"></ng-container>
  </div>
  <div class="rows">
    <div class="upper-row">
      <ng-container *ngIf="upperTemplate" [ngTemplateOutlet]="upperTemplate"></ng-container>
    </div>
    <div class="control-row">
      <div class="content">
        <div class="scrollable">
          <ng-container *ngFor="let tab of tabs; let tabIndex = index">
            <button #tab mat-button [ngClass]="{ active: activeTabIndex === tabIndex }" (click)="setTab(tabIndex)">{{ tab.label | translate }}</button>
          </ng-container>
        </div>
      </div>
      <div *ngIf="showSuffix" class="suffix">
        <ng-container *ngIf="suffixTemplate" [ngTemplateOutlet]="suffixTemplate"></ng-container>
      </div>
    </div>
  </div>
</div>
<div class="subtabs-header">
  <div class="content" *ngIf="(subTabs | filter : notVirtualFunc).length">
    <button mat-icon-button class="prev" (click)="prevSubTab()">
      <mat-icon>chevron_left</mat-icon>
    </button>
    <div class="scrollable">
      <ng-container *ngFor="let subTab of subTabs; let subTabIndex = index">
        <button #subTab mat-button [ngClass]="{ active: activeSubTabIndex === subTabIndex, virtual: subTab.virtual }" (click)="setSubTab(subTabIndex)">
          {{ subTab.label }}
        </button>
      </ng-container>
    </div>
    <button mat-icon-button class="next" (click)="nextSubTab()">
      <mat-icon>chevron_right</mat-icon>
    </button>
  </div>
</div>
